exports.isEmail = function isEmail(value) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
};

exports.isTelephoneNumber = function isEmail(value) {
  var re = /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/;
  return re.test(value);
};



// WEBPACK FOOTER //
// ./src/client/actions/helpers.js